import React from 'react';
import './custom.css';
import logoLeft from '../assets/logo/coat.png';
import logoRight from '../assets/logo/logo.png';

const Header = () => {
  return (
    <>
      <div className="header-wrapper">
        <header className="header-container">
          <img src={logoLeft} alt="Left Logo" className="logo left-logo" />
          <div className="text-container">
            <div className="large-text">ROAD TRAFFIC OFFENCE CHECK</div>
            <div className="small-screen-text">RTOC</div> {/* Small screen text */}
          </div>
          <img src={logoRight} alt="Right Logo" className="logo right-logo" />
        </header>
      </div>
    </>
  );
};

export default Header;
